export default function(state={
    data: {}
}, action) {

    switch(action.type) {
        case "OPTION_SELECTED":
        {
            return {
                data: action.payload.data.tableData
            };
        }

        case "CELL_DATA":
        {
            return {
                data: action.payload.data.tableData.data
            }
        }

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ReducerTable.js